import RouterView from '@/page/main/DefaultRouterView'
import CommonApply from '@/page/common/apply'
import CommonList from '@/page/common/list'

export default {
  path: '/Common',
  component: RouterView,
  children: [{
    path: 'Apply/:applyId?',
    name: 'CommonApply',
    meta: {
      type: ['common', 'commonApply'],
      title: '新建通用审批'
    },
    component: CommonApply
  }, {
    path: 'List',
    meta: {
      type: ['common', 'commonList'],
      title: '通用审批列表'
    },
    component: CommonList
  }, ]
}


// WEBPACK FOOTER //
// ./src/router/common.js